const styles = theme => ({
  root: {

  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/AllCommunication/components/CoreLayout/styles.js